import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import React from "react";
import { IndustryNameData } from "../types";

interface IndustryListProps {
  title: string;
  items: string[];
}

const IndustryList: React.FC<IndustryListProps> = ({ title, items }) => {
  if (!items?.length) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="subtitle2"
        sx={{
          color: "#424242",
          mb: 0.5,
          fontWeight: 500,
        }}
      >
        {title}
      </Typography>
      <List dense disablePadding>
        {items.map((item, index) => (
          <ListItem
            key={index}
            sx={{
              py: 0.5,
              px: 1,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontSize: "12px",
                color: "#666",
              }}
            >
              {item}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export const IndustryTooltipContent: React.FC<{
  data: IndustryNameData;
}> = ({ data }) => {
  const { hgData, sicData, naicsData } = data;

  return (
    <Box sx={{ p: 1, maxWidth: 300, minWidth: 200 }}>
      <IndustryList title="Included Industries" items={hgData.included} />
      <IndustryList title="Included SIC Codes" items={sicData.included} />
      <IndustryList title="Included NAICS Codes" items={naicsData.included} />

      {hgData.excluded.length > 0 && (
        <IndustryList title="Excluded Industries" items={hgData.excluded} />
      )}
      {sicData.excluded.length > 0 && (
        <IndustryList title="Excluded SIC Codes" items={sicData.excluded} />
      )}
      {naicsData.excluded.length > 0 && (
        <IndustryList title="Excluded NAICS Codes" items={naicsData.excluded} />
      )}
    </Box>
  );
};
